import { useContext, useEffect, useState } from "react";
import { BaseApi } from "../base.api";
import { useParams } from "react-router";
import dayjs from "dayjs";
import {
  CheckOutlined,
  CloseOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons";
import utc from "dayjs/plugin/utc";
import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Flex,
  Input,
  InputNumber,
  message,
  Modal,
  Popconfirm,
  PopconfirmProps,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Tag,
} from "antd";
import { Link } from "react-router-dom";
interface DataType {
  _id: string;
  name: string;
  count: number;
}
dayjs.extend(utc);

const CompanyDetailed: React.FC = () => {
  const [company, setCompany] = useState<any>(null);
  const [companies, setCompanies] = useState([]);
  const [mergedData, setMergedData] = useState([]); // Merged data üçün state
  const [selectAllowedCompany, setSelectAllowedCompany] = useState([]);
  const [cache, setCache] = useState<{ data: any; timestamp: number }>({
    data: null,
    timestamp: 0,
  });
  const [users, setUsers] = useState<any[]>([]);
  const [selectUserId, setSelectUserId] = useState({});
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [filteredChildCompany, setFilteredChildCompany] = useState<any[]>([]);
  const [filteredMainCompany, setFilteredMainCompany] = useState<any[]>([]);
  const [jobStatusMetric, setJobStatusMetric] = useState<any[]>([]);
  const [allJobs, setAllJobs] = useState<any[]>([]);
  const [jobs, setJobs] = useState<any[]>([]);
  const [sourceData, setSourceData] = useState<any[]>([]);
  const [allowedSources, setAllowedSources] = useState<any[]>([]);
  const [companySourceData, setComapnySourceData] = useState<any[]>([]);
  const [filterCompanySourceData, setFilterCompanySourceData] = useState<any[]>(
    []
  );
  const [smsRequest, setSmsRequest] = useState<[]>([]);
  const [allSmsRequest, setAllSmsRequest] = useState<[]>([]);
  const [position, setPosition] = useState("");
  const [count, setCount] = useState({
    totalWhatsappCount: 0,
    totalSmsCount: 0,
    totalCount: 0,
  });
  const [price, setPrice] = useState({
    totalWhatsappPrice: 0,
    totalSmsPrice: 0,
    totalPrice: 0,
  });

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedStatuses, setSelectedStatuses] = useState<number[]>([
    2, 3, 5, 6, 7,
  ]);
  const [highlightedCount, setHighlightedCount] = useState<number>(0);
  const [applicationsCount, setApplicationsCount] = useState<number>(0);
  const [userSearch, setUserSearch] = useState<string>("");
  const [isAllowedCompaniesModalOpen, setIsAllowedCompaniesModalOpen] =
    useState(false);
  const [isAddCompanyModalOpen, setIsAddCompanyModalOpen] = useState(false);
  const [isSourceModalOpen, setIsSourceModalOpen] = useState(false);
  const [isEditCompanyModalOpen, setIsEditCompanyModalOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [current, setCurrent] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchTag, setSearchTag] = useState("");
  const [hasNextPage, setHasNextPage] = useState<boolean>(false);
  const { confirm } = Modal;
  const [sourceSearchData, setSourceSearchData] = useState("");
  const [premiumPosts, setPremiumPosts] = useState([]);
  const [selectedCompanySourceRowKeys, setSelectedCompanySourceRowKeys] =
    useState<DataType[]>([]);
  const [selectedSourceRowKeys, setSelectedSourceRowKeys] = useState<
    React.Key[]
  >([]);
  const [isFormSourceValue, setIsFormSourceValue] = useState({
    name: "",
    id: "",
  });

  let { id } = useParams();

  useEffect(() => {
    if (cache?.data) {
      console.log("Cache-də məlumat var, cache-dən istifadə edirik...");
      cacheData(cache.data);
    } else {
      filterParent();
    }
  }, [cache]);

  useEffect(() => {
    loadCompany();
    companyApplications();
  }, []);

  useEffect(() => {
    calculateBillingJobs();
  }, [jobs]);

  useEffect(() => {
    fetchSource();
  }, [current, pageSize, searchTag]);
  useEffect(() => {
    if (company) {
      setPosition(String(company.subscription?.subscriptionAppType));
    }
  }, [company]);

  const calculateBillingJobs = () => {
    try {
      let count = 0;
      jobs.forEach((record) => {
        if (!record.billingActions) return;
        if (
          record.billingActions.findIndex((item: any) => {
            const itemDate = new Date(item.date);
            const isHighlighted =
              itemDate.getFullYear() === selectedYear &&
              itemDate.getMonth() + 1 === selectedMonth;
            return isHighlighted;
          }) > -1
        )
          count++;
      });

      setHighlightedCount(count);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const loadCompany = async () => {
    try {
      const response = await new BaseApi().fetchData(
        "/user-service-v2/companies/" + id + "/for-admin"
      );
      if (response?.data) {
        response.data.subscription.subscriptionDeadline = dayjs.utc(
          response.data.subscription.subscriptionDeadline
        );
        if (
          !response.data.otherDomains ||
          response.data.otherDomains.length == 0
        ) {
          response.data.otherDomains = [""];
        }
        setCompany(response?.data);
        // loadCompanyUsers();
        // loadJobStatusMetrics();
        // loadJobs([1, 2, 3, 5, 6, 7, 8, 9]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const companyApplications = async () => {
    const response = await new BaseApi().fetchData(
      `/candidate-service/applications/count/admin?companyId=${id}`
    );
    setApplicationsCount(response?.data.data);
  };
  const groupAndSort = (data: any) => {
    console.log(data);
    const grouped = data.reduce((acc: any, item: any) => {
      if (!item || !item.name) return acc;
      const key = item.name;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

    const sorted = Object.values(grouped).flat();
    return sorted;
  };
  const companySources = async () => {
    const response = await new BaseApi().fetchData(
      `/reporting-service-v2/report/source/companies/${id}/for-admin`
    );
    const grouped = groupAndSort(response?.data);
    setComapnySourceData(grouped);
    setFilterCompanySourceData(grouped);
    setLoading(false);
  };

  const fetchSource = async () => {
    const offset = (current - 1) * pageSize;
    const limit = pageSize;
    const response = await new BaseApi().fetchData(
      `/common-service/v1/tags/source-tag/admin?offset=${offset}&limit=${limit}&key=${searchTag}`
    );
    if (response?.data.data) {
      setSourceData(response?.data.data);
      setHasNextPage(response?.data.data.length === pageSize);
    } else {
      setSourceData([]);
      setHasNextPage(false);
    }
    let sourceData = response?.data.data;

    if (sourceData && current === 1 && searchTag.trim() === "") {
      const careerPageSource = {
        id: "CAREER_PAGE",
        name: "Career Page",
        count: 0,
        status: 1,
        parent: null,
      };
      sourceData.unshift(careerPageSource);
    }
    setSourceData(sourceData);
  };

  const fetchAllowedSource = async () => {
    setLoading(true);
    const response = await new BaseApi().fetchData(
      `/common-service/v1/allowed-source/company/${id}`
    );
    setAllowedSources(response?.data.sources);

    setLoading(false);
  };
  const searchSourceTag = (value: any) => {
    setSearchTag(value);
    setCurrent(1);
  };
  const premiumPosting = async () => {
    setLoading(true);
    const response = await new BaseApi().fetchData(
      `/job-service-v2/jobs/admin/ads?companyId=${id}`
    );
    const now = new Date();
    if (response?.data) {
      response.data.forEach((item: any) => {
        const expiresAt = new Date(item.expiresAt);
        const diffTime = expiresAt.getTime() - now.getTime();
        const diffDay = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        item.diffDay = diffDay;
        item.lastTime = expiresAt.toString().slice(0, 10);
      });
    }
    console.log(response?.data);

    setPremiumPosts(response?.data);
    setLoading(false);
  };
  const fetchSmsRequest = async () => {
    const response = await new BaseApi().fetchData(
      `/messaging-service-v2/balance/operations/admin/companies/${id}`
    );
    setSmsRequest(response?.data);
    setAllSmsRequest(response?.data);
    handleCvMessageFilter(null, response?.data);
  };

  const transferSource = async (data: any) => {
    try {
      const response = await new BaseApi().postData(
        "/candidate-service/operations/applications/source",
        data
      );
      if (response?.data === true) {
        setSelectedCompanySourceRowKeys([]);
        message.success("Transfer successfully.");
      } else {
        message.error(`Error: ${response?.statusText || "Unknown error"}`);
      }
    } catch (error) {
      message.error("Wrong");
    }
  };

  const filterParent = async () => {
    const now = Date.now();
    const isCacheExpired = now - cache.timestamp >= 5 * 60 * 1000;
    if (!cache.data || isCacheExpired) {
      console.log("5 dəqiqə keçib, yeni məlumatı API-dən çəkirik...");
      const companyData = await new BaseApi().fetchData(
        "/user-service-v2/companies"
      );
      setCache({ data: companyData?.data, timestamp: now });
    }
  };

  const cacheData = async (cache: any) => {
    if (cache) {
      const filterChildCompanies = await cache.filter(
        (company: any) => company.parentId === id
      );
      setFilteredChildCompany(filterChildCompanies);
      const company = await cache?.find((company: any) => company._id === id);
      const filterMainCompany = cache?.filter(
        (c: any) => company.parentId === c._id
      );
      setFilteredMainCompany(filterMainCompany);
      setCompanies(cache);
    }
  };

  const loadCompanyUsers = async () => {
    const response = await new BaseApi().fetchData(
      "user-service-v2/users/company/for-admin?companyId=" + id
    );
    const users = response?.data;
    users.forEach((user: any) => {
      const isAlreadyIncluded =
        user.allowedCompanies?.some(
          (company: any) => company.companyId === user.companyId
        ) ?? false;
      if (!isAlreadyIncluded) {
        user.allowedCompanies = user.allowedCompanies || [];
        const newAllowedCompanies = {
          companyId: user.companyId,
          dateInserted: "",
          isActive: user.status,
          allowToAddChildCompany: "",
          allowToRemoveChildCompany: "",
        };
        user.allowedCompanies.push(newAllowedCompanies);
      }
    });
    setUsers(response?.data);
    setFilteredUsers(response?.data);
  };

  const loadJobStatusMetrics = async () => {
    const response = await new BaseApi().fetchData(
      "/job-service-v2/jobs/company/" + id + "/counts/groupped?criteria=status"
    );
    setJobStatusMetric(response?.data);
  };

  const loadJobs = async (statuses: number[]) => {
    let url =
      "/job-service-v2/jobs/for-admin?companyId=" +
      id +
      "&statusesText=" +
      statuses.toString();

    const response = await new BaseApi().fetchData(url);
    setJobs(
      sortJobsByBilling(
        response?.data?.filter((j: any) => selectedStatuses.includes(j.status))
      )
    );
    setAllJobs(response?.data);
  };

  function getStatus(status: number) {
    switch (status) {
      case 1:
        return "DRAFTED";
      case 2:
        return "ACTIVE";
      case 3:
        return "CLOSED";
      case 5:
        return "ARCHIVED";
      case 6:
        return "INTERNAL";
      case 7:
        return "DELETED";
      case 8:
        return "ORDERED";
      case 9:
        return "REJECTED";
    }
  }

  const convertToDateStr = (isoString: string) => {
    const date = new Date(isoString);
    const formattedDate = date.toString().slice(0, 10);
    return formattedDate;
  };

  const handleClick = async (data: any, record: any) => {
    setIsAllowedCompaniesModalOpen(true);
    const usercompany = record.allowedCompanies.map((company: any) => {
      const companies = cache.data?.find(
        (item: any) => item._id == company.companyId
      );
      if (companies) {
        const companyInfo = data.find((c: any) => c.companyId == companies._id);
        return {
          key: companies._id,
          companyName: companies.name,
          dateInserted: companyInfo.dateInserted || companies.createdAt,
          isActive: companyInfo.isActive,
          isSuperAdmin: record.isSuperAdmin || false,
          role: record.roleProfile,
          allowToAddChildCompany: companyInfo.allowToAddChildCompany,
          allowToRemoveChildCompany: companyInfo.allowToRemoveChildCompany,
        };
      }
    });
    setMergedData(usercompany);
  };
  const addAllowedCompany = async (data: any) => {
    setLoading(true);
    const allowedCompanies = data.allowedCompanies.map((allowed: any) =>
      companies.find((company: any) => company._id == allowed.companyId)
    );
    setSelectAllowedCompany(
      allowedCompanies.map((company: any) => company?._id)
    );
    setSelectUserId(data._id);
    setIsAddCompanyModalOpen(true);
    setLoading(false);
  };

  const handleOk = async () => {
    new BaseApi()
      .putData(
        `/user-service-v2/users/${selectUserId}/allowed-compamnies/by-admin`,
        { ids: selectAllowedCompany }
      )
      .then((res: any) => {
        if (res.message == 200) {
          message.success("Operation completed successfully");
        }
      });

    setIsAddCompanyModalOpen(false);
    setSelectAllowedCompany([]);
  };

  const handleSubmitSourceEdit = async () => {
    const id = isFormSourceValue.id;
    console.log(isFormSourceValue);

    await new BaseApi().putData(
      `common-service/v1/tags/source-tag/${id}`,
      isFormSourceValue
    );

    setIsEditCompanyModalOpen(false);
    companySources();
    fetchSource();
  };

  const handleModalClose = () => {
    setIsAllowedCompaniesModalOpen(false);
    setIsAddCompanyModalOpen(false);
    setIsSourceModalOpen(false);
    setSearchTag("");
    setSelectedSourceRowKeys([]);
    setIsEditCompanyModalOpen(false);
  };
  const handleModal = (param: any) => {
    console.log(param);

    setIsEditCompanyModalOpen(true);
    setIsFormSourceValue({ name: param.name, id: param._id || param.id });
  };
  const handleModalOk = () => {
    handleSubmitSourceEdit();
    loadCompany();
  };

  const changeCompanySourceValue = (e: any) => {
    setIsFormSourceValue({ ...isFormSourceValue, name: e.target.value });

    console.log(e.target.value);
  };

  const sourceDelete = async (id: string) => {
    try {
      const response = await new BaseApi().deleteData(
        `/common-service/v1/tags/source-tag/${id}`
      );

      if (response?.status === 200) {
        message.success("Deleted successfully");
        console.log("successfully");
      } else {
        message.error("Unknown error");
        console.log("Failed");
      }
    } catch (err) {
      message.error("Server error");
      console.error("Deletion failed:", err);
    }
  };
  const deleteAllowedSource = async (sourceId: any) => {
    const response = await new BaseApi().deleteData(
      `/common-service/v1/allowed-source/company/${id}/source/${sourceId}`
    );
    if (response?.data == true) {
      message.success("successfully deleted");
      fetchAllowedSource();
    }
  };
  const deletePremiumSource = async (jobsId: any, postingId: any) => {
    const response = await new BaseApi().deleteData(
      `/job-service-v2/jobs/${jobsId}/portal-posts/${postingId}/by-admin?companyId=${id}`
    );
    if (response?.data === true) {
      message.success("successfully");
    }
    message.error("error");
  };

  const allowCompanyCols = [
    {
      title: "Name",
      key: "name",
      render: (record: any) => <span>{record.companyName}</span>,
    },
    {
      title: "Date Inserted",
      key: "dateInserted",
      render: (record: any) => {
        const time = new Date(record.dateInserted).toLocaleString();
        return <Tag color="green">{time}</Tag>;
      },
    },
    {
      title: "Status",
      key: "isActive",
      render: (record: any) => {
        return record.isActive == true ? "Active" : "Deactive";
      },
    },
    {
      title: "Role",
      key: "roleProfile",
      render: (record: any) => {
        return record.isSuperAdmin ? "SuperAdmin" : record.role;
      },
    },

    {
      title: "Allow To Add Child Company",
      key: "allowToAddChildCompany",
      render: (record: any) => {
        return record.allowToAddChildCompany === true ? "Yes" : "No";
      },
    },
    {
      title: "Allow To Remove Child Company",
      key: "allowToRemoveChildCompany",
      render: (record: any) => {
        return record.allowToRemoveChildCompany === true ? "Yes" : "No";
      },
    },
  ];

  const userCols = [
    {
      title: "Name",
      key: "name.first",
      render: (record: any) => <span>{record.name.first}</span>,
    },
    {
      title: "Surname",
      render: (record: any) => <span>{record.name.last}</span>,
      key: "domain",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      render: (record: any) => (
        <>
          <Button onClick={(e) => addAllowedCompany(record)}>
            Access to company
          </Button>
        </>
      ),
    },
    {
      render: (record: any) => {
        if (record.allowedCompanies.length > 1) {
          return (
            <>
              <Button
                onClick={(e) => handleClick(record.allowedCompanies, record)}
              >
                {" "}
                Allowed Companies
              </Button>
            </>
          );
        }
      },
    },

    {
      title: "Status",
      key: "status",
      render: (record: any) => (record.status == 1 ? "Active" : "Deactive"),
    },
    {
      render: (record: any) => (
        <Button
          onClick={() => changeUserStatus(record.status, record._id)}
          variant="outlined"
          style={{ width: "80px" }}
          color={record.status == 1 ? "danger" : "blue"}
        >
          {record.status == 1 ? "Deactivate" : "Activate"}
        </Button>
      ),
    },
    {
      title: "Role",
      key: "role",
      render: (record: any) =>
        record.isSuperAdmin ? "superAdmin" : record.roleProfile,
    },
    {
      key: "isSuperAdmin",
      render: (record: any) => (
        <Button
          // type = 'link'
          variant="link"
          color={record.isSuperAdmin ? "danger" : "primary"}
          onClick={() => changeRole(record.id)}
        >
          {record.isSuperAdmin
            ? record.isSuperAdmin == false &&
              record.roleProfile === "companyAdmin"
              ? "Make SuperAdmin"
              : record.isSuperAdmin === true
              ? "Remove SuperAdmin"
              : ""
            : record.roleProfile === "companyAdmin"
            ? "Make SuperAdmin"
            : record.isSuperAdmin === true}
        </Button>
      ),
    },
  ];
  const sourceCols = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Number",
      key: "count",
      dataIndex: "count",
    },
    {
      render: (record: any) => {
        if (record._id !== "CAREER_PAGE") {
          return <Button onClick={() => handleModal(record)}>Edit</Button>;
        }
      },
    },
    {
      render: (record: any) => {
        if (record._id !== "CAREER_PAGE") {
          return (
            <Button onClick={() => sourceDelete(record.id || record._id)}>
              Delete
            </Button>
          );
        }
      },
    },
  ];

  const smsCols = [
    {
      title: "Type",
      // dataIndex: "type",
      key: "type",
      render: (record: any) => <Button type="link">{record.type}</Button>,
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      render: (record: any) => {
        let price = record.price * record.count;
        price = Math.round(price * 100) / 100;
        return <Tag style={{width:"20%"}}> {price}</Tag>;
      },
    },
    {
      title: "Created At",
      key: "createdAt",
      render: (record: any) => (
        <Tag color="green">{record.createdAt.toString().slice(0, 10)}</Tag>
      ),
    },
  ];

  const jobCols = [
    {
      title: "Title",
      key: "title",
      dataIndex: "title",
    },
    {
      title: "Status",
      key: "status",
      render: (record: any) => <span>{getStatus(record.status)}</span>,
    },

    {
      title: "First Published Date",
      key: "firstPublishedDate",
      render: (record: any) => (
        <span>
          {record.postedDate ? convertToDateStr(record.postedDate) : "N/A"}
        </span>
      ),
    },
    {
      title: "Last Published Date",
      key: "lastPublishedDate",
      render: (record: any) => (
        <span>
          {record.lastPostedDate
            ? convertToDateStr(record.lastPostedDate)
            : "N/A"}
        </span>
      ),
    },
    {
      title: "Closing Date",
      key: "closingDate",
      render: (record: any) => (
        <span>
          {record.closedDate ? convertToDateStr(record.closedDate) : "N/A"}
        </span>
      ),
    },
    {
      title: "Archive Date",
      key: "archivedDate",
      render: (record: any) => (
        <span>
          {record.archivedDate ? convertToDateStr(record.archivedDate) : ""}
        </span>
      ),
    },
    {
      title: "Billing",
      key: "billing",
      render: (record: any) => {
        // Filter to show only highlighted items
        const highlightedActions = record.billingActions?.filter(
          (item: any) => {
            const itemDate = new Date(item.date);
            return (
              itemDate.getFullYear() === selectedYear &&
              itemDate.getMonth() + 1 === selectedMonth
            );
          }
        );

        // Render the filtered billingActions
        return (
          <div>
            {highlightedActions?.map((item: any) => (
              <div
                key={item.date}
                style={{
                  borderBottom: "1px solid lightgray",
                  backgroundColor: "yellow",

                  padding: "5px",
                  textAlign: "center",
                }}
              >
                {convertToDateStr(item.date)} - {item.action}
              </div>
            ))}
          </div>
        );
      },
    },
  ];

  const cancel: PopconfirmProps["onCancel"] = (e) => {
    console.log(e);
    message.error("Uknow error");
  };
  const onOk: PopconfirmProps["onConfirm"] = (e: any) => {
    deletePremiumSource(e.jobId, e.id);
  };

  const months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const years = Array.from({ length: 20 }, (_, index) => {
    const currentYear = new Date().getFullYear();
    return currentYear - 4 + index; // Range: 10 years before and after current year
  });

  const premiumPostColumn = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Premium Type",
      key: "type",
      render: (record: any) =>
        record.isKingAd === true ? (
          <Tag
            color="purple"
            style={{ fontStyle: "italic", width: "40%", textAlign: "center" }}
          >
            King
          </Tag>
        ) : record.isProAd === true ? (
          <Tag
            color="blue"
            style={{ fontStyle: "italic", width: "40%", textAlign: "center" }}
          >
            Pro
          </Tag>
        ) : (
          ""
        ),
    },

    {
      title: "Posted Date",
      render: (record: any) => <Tag>{convertToDateStr(record.postedAt)}</Tag>,
      key: "postedAt",
    },
    {
      title: "Expires At",
      render: (record: any) =>
        record.diffDay < 0 ? (
          <Tag color="red">
            {record.lastTime}/ {record.diffDay} day
          </Tag>
        ) : (
          <Tag color="green">
            {record.lastTime} / {record.diffDay} day
          </Tag>
        ),

      key: "expiresAt",
    },
    {
      title: "Status",
      key: "status",
      render: (record: any) =>
        getStatus(record.status) ? (
          <Tag>{getStatus(record.status)}</Tag>
        ) : (
          "N/A"
        ),
    },

    {
      // title: "Approved",
      key: "isApproved ",
      render: (record: any) =>
        record.isApproved === true ? (
          <Tag color="green">Approved</Tag>
        ) : (
          <Tag color="red">UnApproved</Tag>
        ),
    },
    {
      render: (record: any) => (
        <Popconfirm
          style={{ marginRight: "40px" }}
          title="Cancel Premium"
          description="Are you sure you want to cancel Premium?"
          onCancel={cancel}
          onConfirm={() => onOk(record)}
          okText="Yes"
          cancelText="No"
        >
          <Button color="danger" variant="link">
            Cancel
          </Button>
        </Popconfirm>
      ),
    },
  ];

  const allowedSource = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Action",
      render: (record: any) => (
        <>
          <div style={{ display: "flex", gap: "20px" }}>
            <Button>
              <Link
                state={{ name: record.name }}
                to={`allowed-source/${record._id}/update`}
              >
                Edit
              </Link>
            </Button>
            <Button onClick={(e) => deleteAllowedSource(record._id)}>
              Delete
            </Button>
          </div>
        </>
      ),
    },
  ];

  const changeRole = async (userId: any) => {
    try {
      const response = await new BaseApi().patchData(
        `user-service-v2/users/company/${userId}/superadmin/by-admin`
      );
      if (response?.status === 200) {
        loadCompanyUsers();
        message.success("Role updated successfully.");
      }
    } catch (error) {
      console.error("Error updating role:", error);
      message.error("An error occurred while updating role.");
    }
  };
  const changeUserStatus = async (status: any, id: string) => {
    console.log(status, id);

    confirm({
      title:
        status == 1
          ? "Are you sure yoy want to deactivate the status?"
          : "Are you sure yoy want to activate the status?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          const api = new BaseApi();
          if (status == 1) {
            const response = await api.putData(
              `/user-service-v2/users/company/${id}/deactivate/by-admin`,
              {}
            );
            if (response?.status === 200) {
              loadCompanyUsers();
              message.success("Status changed.");
            }
          } else {
            const response = await api.putData(
              `/user-service-v2/users/company/${id}/activate/by-admin`,
              {}
            );
            if (response?.status === 200) {
              loadCompanyUsers();
              message.success("Status changed");
            }
          }
        } catch (error) {
          console.error("Error changing status:", error);
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleChange = (value: number) => {
    console.log(`Selected month: ${value}`);
    setSelectedMonth(value);
    const jobsClone =
      selectedStatuses.length == 0
        ? [...allJobs]
        : [
            ...sortJobsByBilling(
              allJobs.filter((j) => selectedStatuses.includes(j.status))
            ),
          ];

    setJobs(jobsClone);
  };

  const sortJobsByBilling = (jobs: any[]) => {
    return jobs.sort((a, b) => {
      // Helper function to determine if billingActions contains an isHighlighted item
      const hasHighlightedItem = (billingActions: any[]) => {
        return billingActions?.some((item: any) => {
          const itemDate = new Date(item.date);
          return (
            itemDate.getFullYear() === selectedYear &&
            itemDate.getMonth() + 1 === selectedMonth
          );
        });
      };

      // Check for isHighlighted in a and b
      const aHasHighlighted = hasHighlightedItem(a.billingActions);
      const bHasHighlighted = hasHighlightedItem(b.billingActions);

      // Sort logic: if a has highlighted and b doesn't, a comes first
      if (aHasHighlighted && !bHasHighlighted) return -1;
      if (!aHasHighlighted && bHasHighlighted) return 1;
      return 0; // If both are highlighted or both are not, maintain original order
    });
  };

  const handleYearChange = (value: number) => {
    console.log(`Selected year: ${value}`);
    setSelectedYear(value);
    const jobsClone =
      selectedStatuses.length == 0
        ? [...allJobs]
        : [
            ...sortJobsByBilling(
              allJobs.filter((j) => selectedStatuses.includes(j.status))
            ),
          ];

    setJobs(jobsClone);
  };

  const handleSelectStatus = (status: number) => {
    const statusesClone = [...selectedStatuses];
    if (statusesClone.indexOf(status) > -1) {
      statusesClone.splice(statusesClone.indexOf(status), 1);
    } else statusesClone.push(status);

    setSelectedStatuses(statusesClone);

    const jobsClone =
      statusesClone.length == 0
        ? [...allJobs]
        : [
            ...sortJobsByBilling(
              allJobs.filter((j) => statusesClone.includes(j.status))
            ),
          ];

    setJobs(jobsClone);
  };

  const onLicDateChange = (e: any) => {
    console.log("[onLicDateChange] e ", e);
    setCompany({
      ...company,
      subscription: { ...company.subscription, subscriptionDeadline: e },
    });
  };

  const onSmsCountChange = (e: any) => {
    console.log("[onSmsCountChange] e ", e);
    setCompany({
      ...company,
      subscription: { ...company.subscription, smsCount: e },
    });
  };

  const onPlanChange = (e: any) => {
    console.log("[onPlanChange] e ", e);
    setCompany({
      ...company,
      subscription: { ...company.subscription, subscriptionType: e },
    });
  };
  const onParentChange = (Id: any) => {
    const newId = Id.trim();
    setCompany({
      ...company,
      parentId: newId,
    });
  };
  const handleSaveCompany = () => {
    new BaseApi()
      .putData("/user-service-v2/companies/" + company._id + "/by-admin", {
        subscriptionDeadline:
          company.subscription.subscriptionDeadline.toDate(),
        smsCount: company.subscription.smsCount,
        domain: company.domain,
        otherDomains: company.otherDomains,
        subscriptionJobLimit: Number(company.subscription.subscriptionJobLimit),
        subscriptionType: Number(company.subscription.subscriptionType),
        subscriptionAppType: Number(company.subscription.subscriptionAppType),
        parentId: company.parentId?.trim() || "",
        sharedFolderEnabled: company.sharedFolderEnabled,
        cvScreeningEnabled: company.cvScreeningEnabled,
      })
      .then((res: any) => {
        if (res?.status == 200) {
          message.success("Operation completed successfully");
        }
      })
      .catch((error) => {
        console.error("Request error:", error.response?.data);
      });
  };

  const handleDomainChange = (e: any) => {
    console.log("[handleDomainChange] value ", e.target.value);
    const cloneCompany: any = { ...company };
    cloneCompany.domain = e.target.value.trim();
    setCompany(cloneCompany);
  };
  const handleSwitchChange = (checked: boolean) => {
    console.log("[handleChangeSwitch] value ", checked);
    const cloneCompany: any = { ...company };
    cloneCompany.sharedFolderEnabled = checked;
    setCompany(cloneCompany);
  };

  const handleSlugChange = (e: any) => {
    console.log("[handleSlugChange] value ", e.target.value);
  };
  const handleAppTypeChange = (e: any) => {
    console.log(e.target.value);
    const cloneCompany: any = { ...company };
    cloneCompany.subscription.subscriptionAppType = e.target.value;
    setCompany(cloneCompany);
  };

  const handleCvScreeningChange = (checked: boolean) => {
    console.log(checked);

    const cloneCompany: any = { ...company };
    cloneCompany.cvScreeningEnabled = checked;
    setCompany(cloneCompany);
  };

  const handleLimitChange = (e: any) => {
    console.log(e.target.value);
    const cloneCompany: any = { ...company };
    cloneCompany.subscription.subscriptionJobLimit = e.target.value;
    setCompany(cloneCompany);
  };
  const changeCompanySourceSearch = async (value: any) => {
    setSourceSearchData(value);
    const escapedVal = value.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, "\\$&");
    const regex = new RegExp(escapedVal, "i");
    const searchSourceData = companySourceData.filter((item) => {
      const searchData = regex.test(item.name);
      return searchData;
    });
    console.log(searchSourceData);

    setFilterCompanySourceData(searchSourceData);
  };

  const handleChangeOtherDomain = (e: any, index: number) => {
    console.log("[handleChangeOtherDomain] e ", e, " index ", index);
    const cloneCompany: any = { ...company };
    cloneCompany.otherDomains[index] = e.target.value.trim();
    setCompany(cloneCompany);
  };

  const handleAddOtherDomain = () => {
    console.log("[handleAddOtherDomain] ");
    const cloneCompany: any = { ...company };
    cloneCompany.otherDomains.push("");
    setCompany(cloneCompany);
  };

  const handleRemoveOtherDomain = (index: number) => {
    console.log("[handleAddOtherDomain] index ", index);
    const cloneCompany: any = { ...company };
    cloneCompany.otherDomains.splice(index, 1);
    setCompany(cloneCompany);
  };

  const handleSearchUser = (e: any) => {
    console.log("[handleSearchUser] ", e.target.value.trim());

    const regex = new RegExp(e.target.value.trim(), "i"); // 'i' makes it case-insensitive

    setUserSearch(e.target.value);
    if (!e.target.value || e.target.value.trim().length == 0)
      setFilteredUsers(users);
    else
      setFilteredUsers(
        users.filter(
          (item) =>
            regex.test(item.name.first) ||
            regex.test(item.name.last) ||
            regex.test(item.email) ||
            regex.test(item.roleProfile)
        )
      );
  };

  const getPlan = (type: number) => {
    switch (type) {
      case 1:
        return "Trial";
      case 2:
        return "Monthly";
      case 3:
        return "Yearly";
      case 4:
        return "PayAsYouGo";
      case 5:
        return "MonthlyUnlimited";
      case 6:
        return "YearlyUnlimited";
      case 7:
        return "Hybrid";
      case 8:
        return "Flex";
      default:
        return "Unknown Subscription Type";
    }
  };
  const handleTransfer = () => {
    setIsSourceModalOpen(true);
    fetchSource();
  };
  const transferConfirm = () => {
    confirm({
      title: "Transfer the source",
      content: "Are you sure to tranfer these sources",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        handleTransfermModal();
        searchSourceTag("");
      },
    });
  };
  const handleTransfermModal = () => {
    setSelectedSourceRowKeys([]);
    setIsSourceModalOpen(false);
    const companySourceId = selectedCompanySourceRowKeys.map(
      (item) => item._id
    );
    const sourceId = selectedSourceRowKeys[0];
    const isCareerPage = sourceId === "CAREER_PAGE";

    const data = {
      companyId: id,
      appIds: companySourceId,
      toCareerPage: isCareerPage,
      toSourceId: sourceId,
    };
    console.log(data);

    transferSource(data);
  };
  const handlePaginationChange = (current: any, pageSize: any) => {
    setCurrent(current);
    setPageSize(pageSize);
  };
  const handleCvMessageFilter = (date: dayjs.Dayjs | null, data: any) => {
    let filtered: any = data;
    if (date) {
      const selectedMonth = date.format("YYYY-MM");
      filtered = allSmsRequest.filter((item: any) => {
        const itemMonth = dayjs(item.createdAt).format("YYYY-MM");
        return itemMonth === selectedMonth;
      });
    }

    let totalWhatsappCount = 0;
    let totalSmsCount = 0;
    let whatsappPrice = 0;
    let smsPrice = 0;
    filtered.forEach((item: any) => {
      const count = item.count || 0;
      const price = item.price || 0;
      if (item.type == "whatsapp") {
        totalWhatsappCount += count;
        whatsappPrice = price
      } else if (item.type == "sms") {
        totalSmsCount += count;
        smsPrice = price

      }
    });

    const totalWhatsappPrice = Math.round((totalWhatsappCount * whatsappPrice) * 100) / 100;
    const totalSmsPrice = Math.round((totalSmsCount*smsPrice) * 100) / 100;
    const totalPrice =  totalWhatsappPrice + totalSmsPrice
    const totalCount = totalWhatsappCount + totalSmsCount
    setSmsRequest(filtered);
    setCount({
      totalCount,
      totalWhatsappCount,
      totalSmsCount,
    });
    setPrice({
      totalPrice,
      totalWhatsappPrice,
      totalSmsPrice,
    });
  };

  const start = () => {
    setLoading(true);
    setTimeout(() => {
      setSelectedCompanySourceRowKeys([]);
      setLoading(false);
    }, 1000);
  };
  const onSelectChange = (
    selectedRowKeys: React.Key[],
    selectedRows: DataType[]
  ) => {
    setSelectedCompanySourceRowKeys(selectedRows);
  };

  const rowSelection = {
    selectedRowKeys: selectedCompanySourceRowKeys.map((item) => item._id),
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };
  const rowSelectionSource = {
    selectedRowKeys: selectedSourceRowKeys,
    onChange: (selectedKeys: any) => setSelectedSourceRowKeys(selectedKeys),
  };
  const hasSelected = selectedCompanySourceRowKeys.length > 0;

  const CompanyColumns = [
    {
      title: "Name",
      key: "name",
      render: (record: any) => (
        <a href={"/main/companies/" + record._id}>{record.name}</a>
      ),
    },
    {
      title: "Domain",
      key: "domain",
      render: (record: any) => (
        <a href={"https://" + record.domain} target="_blank">
          {record.domain}
        </a>
      ),
    },
    {
      title: "Plan",
      key: "plan",
      render: (record: any) => (
        <Tag>{getPlan(record.subscription.subscriptionType)}</Tag>
      ),
    },
    {
      title: "Subsription ends",
      key: "subscription",
      render: (record: any) => {
        const time = new Date(record.subscription.subscriptionDeadline);
        if (time < new Date()) {
          return <Tag color="red">{time.toLocaleString()}</Tag>;
        }
        return <Tag color="green">{time.toLocaleString()}</Tag>;
      },
    },
  ];

  return company ? (
    <>
      <Modal
        width={1000}
        open={isAllowedCompaniesModalOpen}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        onCancel={handleModalClose}
      >
        <Table dataSource={mergedData || []} columns={allowCompanyCols} />
      </Modal>
      <Modal
        width={800}
        open={isAddCompanyModalOpen}
        onOk={handleOk}
        cancelButtonProps={{ disabled: true }}
        onCancel={handleModalClose}
      >
        <Select
          style={{ width: "100%", marginTop: "30px" }}
          mode="multiple"
          value={selectAllowedCompany}
          options={companies.map((item: any) => ({
            key: item._id,
            value: item._id,
            label: item.name
              ? `${item.name}:   ${item.domain}`
              : `N/A:  ${item.domain}`,
          }))}
          onChange={(value) => setSelectAllowedCompany(value)}
        ></Select>
      </Modal>
      <Modal
        width={1000}
        open={isSourceModalOpen}
        onCancel={handleModalClose}
        onOk={transferConfirm}
      >
        <Input
          value={searchTag}
          placeholder="search..."
          style={{ width: "30%" }}
          onChange={(e) => searchSourceTag(e.target.value)}
        />

        <Table
          style={{ marginTop: "28px" }}
          rowSelection={rowSelectionSource}
          rowKey="id"
          dataSource={sourceData}
          columns={sourceCols}
          pagination={{
            current,
            pageSize,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            onChange: handlePaginationChange,
            total: hasNextPage ? current * pageSize + 1 : current * pageSize,
            simple: true,
            showTitle: false,
            showQuickJumper: false,
            showTotal: () => null,
          }}
          loading={loading}
        />
      </Modal>
      <Modal
        width={1000}
        open={isEditCompanyModalOpen}
        onCancel={handleModalClose}
        onOk={handleModalOk}
      >
        <label>Name</label>
        <Input
          value={isFormSourceValue.name}
          onChange={(e) => changeCompanySourceValue(e)}
        />
      </Modal>
      <Button>
        <a href="/main/companies/">Main page</a>
      </Button>
      <div>
        <div
          style={{
            display: "inline-block",
            width: "20px",
            height: "20px",
            borderRadius: "10px",
            backgroundColor:
              new Date().getTime() <
              new Date(company.subscription.subscriptionDeadline).getTime()
                ? "green"
                : "red",
          }}
        ></div>
        <h1 style={{ marginLeft: "10px", display: "inline-block" }}>
          {company.name}
        </h1>
      </div>
      <a href={"https://" + company.domain} target="_blank">
        {company.domain}
      </a>
      {filteredChildCompany && filteredChildCompany.length > 0 && (
        <Collapse
          style={{ width: "100%", marginTop: "20px" }}
          items={[
            {
              key: "child",
              label: "Child Companies",
              children: (
                <Table
                  columns={CompanyColumns}
                  dataSource={filteredChildCompany}
                  rowKey="_id"
                  scroll={{ x: true }}
                />
              ),
            },
          ]}
        />
      )}
      {filteredMainCompany && filteredMainCompany.length > 0 && (
        <Collapse
          style={{ width: "100%", marginTop: "20px" }}
          items={[
            {
              key: "main",
              label: "Main Company",
              children: (
                <Table
                  columns={CompanyColumns}
                  dataSource={filteredMainCompany}
                  rowKey="_id"
                  scroll={{ x: true }}
                />
              ),
            },
          ]}
        />
      )}
      <Row>
        <Col span={24}>
          <Collapse
            style={{ width: "100%", marginTop: "20px" }}
            accordion={true}
            defaultActiveKey={["edi"]}
            items={[
              {
                key: "1",
                label: "Edit company",
                children: (
                  <>
                    <Row>
                      <Col>
                        <div>Domain</div>
                        <Input
                          value={company.domain}
                          onChange={handleDomainChange}
                        />
                      </Col>
                    </Row>
                    {filteredChildCompany &&
                      filteredChildCompany.length > 0 && (
                        <Row style={{ marginTop: "15px" }}>
                          <div style={{ display: "flex", gap: "30px" }}>
                            <div>Shared folder</div>
                            <Switch
                              checked={company.sharedFolderEnabled}
                              onChange={handleSwitchChange}
                            />
                          </div>
                        </Row>
                      )}

                    <Row style={{ marginTop: "10px" }}>
                      <Col>
                        <div>Slug</div>
                        <Input
                          value={company.slug}
                          disabled
                          onChange={handleSlugChange}
                        />
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                      <Col>
                        <div>Vacancy Limit</div>
                        <Input
                          value={company.subscription.subscriptionJobLimit}
                          onChange={handleLimitChange}
                        />
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                      <Col>
                        <div>Other domains</div>
                        {company.otherDomains.map(
                          (item: string, index: number) => (
                            <div key={index} style={{ marginTop: "5px" }}>
                              <Input
                                value={item}
                                onChange={(e: any) =>
                                  handleChangeOtherDomain(e, index)
                                }
                              />
                              <Button
                                style={{
                                  position: "absolute",
                                  height: "30px",
                                  width: "30px",
                                }}
                                onClick={() => handleRemoveOtherDomain(index)}
                                size="small"
                              >
                                X
                              </Button>
                            </div>
                          )
                        )}
                        <Button onClick={handleAddOtherDomain}>Add</Button>
                      </Col>
                    </Row>

                    <Row style={{ marginTop: "20px" }}>
                      <Col xs={24} lg={6}>
                        <span>Deadline</span>{" "}
                        <DatePicker
                          allowClear={false}
                          onChange={onLicDateChange}
                          value={company.subscription.subscriptionDeadline}
                        />
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "20px" }}>
                      <Col xs={24} lg={3}>
                        <span>Sms count</span>{" "}
                        <InputNumber
                          min={1}
                          max={1000000}
                          // value={company.smsCount}
                          // onChange={onSmsCountChange}
                        />
                      </Col>
                      <Col xs={24} lg={18}>
                        <span>Whatsapp count</span>{" "}
                        <InputNumber
                          min={1}
                          max={1000000}
                          // value={company.subscription.wha}
                          // onChange={onSmsCountChange}
                        />
                      </Col>
                    </Row>

                    <Row style={{ marginTop: "20px" }}>
                      <Col xs={24} lg={6}>
                        <span>Plan</span>
                        <Select
                          style={{ width: "100%" }}
                          onChange={onPlanChange}
                          placeholder="Select plan"
                          value={company.subscription.subscriptionType.toString()}
                        >
                          <Select.Option value="1">Trial</Select.Option>
                          <Select.Option value="2">Monthly</Select.Option>
                          <Select.Option value="3">Yearly</Select.Option>
                          <Select.Option value="4">PayAsYouGo</Select.Option>
                          <Select.Option value="5">
                            Monthly Unlimited
                          </Select.Option>
                          <Select.Option value="6">
                            Yearly Unlimited
                          </Select.Option>
                          <Select.Option value="7">Hybrid</Select.Option>
                          <Select.Option value="8">Flex</Select.Option>
                        </Select>
                      </Col>
                    </Row>

                    <Row style={{ marginTop: "20px" }}>
                      <Col xs={24} lg={6}>
                        <span>Parent company</span>
                        <Select
                          style={{ width: "100%" }}
                          value={company.parentId || undefined}
                          onChange={onParentChange}
                        >
                          {cache?.data?.map((company: any) => {
                            if (company.name) {
                              return (
                                <Select.Option
                                  key={company._id}
                                  value={company._id}
                                >
                                  {company.name}
                                </Select.Option>
                              );
                            }
                          })}
                        </Select>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "20px" }}>
                      <Col xs={24} lg={6}>
                        <span>Change Ats</span>
                        <div>
                          <Space>
                            <Radio.Group
                              value={position}
                              onChange={handleAppTypeChange}
                              buttonStyle="solid"
                            >
                              <Radio.Button value="1">Full</Radio.Button>
                              <Radio.Button value="2">Limited</Radio.Button>
                            </Radio.Group>
                          </Space>
                        </div>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "20px" }}>
                      <Col xs={24} lg={6}>
                        <span style={{ marginRight: "20px" }}>
                          CV Screening{" "}
                        </span>
                        <Switch
                          checked={company.cvScreeningEnabled}
                          onChange={handleCvScreeningChange}
                        />
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "20px" }}>
                      <Col>
                        <Button type="primary" onClick={handleSaveCompany}>
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </>
                ),
              },
            ]}
          ></Collapse>
        </Col>
      </Row>
      <Collapse
        style={{ width: "100%", marginTop: "20px" }}
        accordion={true}
        defaultActiveKey={["usa"]}
        onChange={loadCompanyUsers}
        items={[
          {
            key: "user",
            label: "Company users",
            children: (
              <>
                <h3>Users</h3>
                <Input
                  allowClear
                  value={userSearch}
                  onChange={handleSearchUser}
                  style={{ width: "300px" }}
                  placeholder="Search..."
                />
                <Table
                  style={{ marginTop: "20px", width: "100%" }}
                  scroll={{ x: true }}
                  dataSource={filteredUsers}
                  columns={userCols}
                  rowKey="_id"
                />
              </>
            ),
          },
        ]}
      ></Collapse>
      <Collapse
        style={{ width: "100%", marginTop: "20px" }}
        accordion={true}
        defaultActiveKey={["sou"]}
        onChange={() => companySources()}
        items={[
          {
            key: "source",
            label: "Source",
            children: (
              <>
                <Flex gap="5px" vertical>
                  <Flex align="center" justify="space-between">
                    <Flex gap="12px">
                      <Button
                        type="primary"
                        onClick={start}
                        disabled={!hasSelected}
                        loading={loading}
                      >
                        Reload
                      </Button>
                      <Input
                        allowClear
                        value={sourceSearchData}
                        onChange={(e) =>
                          changeCompanySourceSearch(e.target.value)
                        }
                        style={{ width: "300px" }}
                        placeholder="Search..."
                      />
                    </Flex>
                    <div>
                      <Button onClick={handleTransfer}>Transfer</Button>
                    </div>
                  </Flex>
                  {hasSelected ? (
                    <>
                      <h3 style={{ marginBottom: "-3px" }}>
                        Selected {selectedCompanySourceRowKeys.length} items:
                      </h3>
                      <p>
                        {selectedCompanySourceRowKeys
                          .map((item) => item.name)
                          .join(",  ")}
                      </p>
                    </>
                  ) : null}

                  <Table<DataType>
                    rowSelection={rowSelection}
                    columns={sourceCols}
                    dataSource={filterCompanySourceData}
                    rowKey="_id"
                    loading={loading}
                  />
                </Flex>
              </>
            ),
          },
        ]}
      ></Collapse>
      <Collapse
        defaultActiveKey={["allows"]}
        style={{ width: "100%", marginTop: "20px" }}
        onChange={fetchAllowedSource}
        items={[
          {
            key: "allowsource",
            label: "Allowed Source",
            children: (
              <>
                <Row gutter={20}>
                  <Col span={8}>
                    <Input placeholder="Search source tag..." />
                  </Col>
                  <Col span={4}>
                    <Button>
                      <Link to={`allowed-source/add`}>Add Source</Link>
                    </Button>
                  </Col>
                </Row>
                <Table
                  loading={loading}
                  rowKey="_id"
                  style={{ marginTop: "12px" }}
                  columns={allowedSource}
                  dataSource={allowedSources}
                ></Table>
              </>
            ),
          },
        ]}
      ></Collapse>
      <Collapse
        style={{ width: "100%", marginTop: "20px" }}
        accordion={true}
        defaultActiveKey={["smsa"]}
        onChange={fetchSmsRequest}
        items={[
          {
            key: "sms",
            label: "Messaging requests",
            children: (
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h3 style={{ marginBottom: "30px" }}>Messaging Requests</h3>
                  <DatePicker
                    style={{
                      marginRight: "20px",
                      width: "170px",
                      height: "45px",
                    }}
                    picker="month"
                    onChange={handleCvMessageFilter}
                  />
                </div>
                <Table
                  dataSource={smsRequest}
                  columns={smsCols}
                  rowKey="_id"
                  pagination={{ pageSize: 20 }}
                />

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={6}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <Tag style={{ padding: "8px", fontSize: "13px" }}>
                        Total Whatsapp Count : {count.totalWhatsappCount}
                      </Tag>
                      <Tag style={{ padding: "8px", fontSize: "13px" }}>
                        Total Whatsapp Price : {price.totalWhatsappPrice}
                      </Tag>
                      
                    </div>
                  </Col>

                  <Col xs={24} md={6}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <Tag style={{ padding: "8px", fontSize: "13px" }}>
                        Total SMS Count : {count.totalSmsCount}
                      </Tag>
                      <Tag style={{ padding: "8px", fontSize: "13px" }}>
                        Total SMS Price : {price.totalSmsPrice }
                      </Tag>
                     
                    </div>
                  </Col>

                  <Col xs={24} md={6}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <Tag style={{ padding: "8px", fontSize: "13px" }}>
                        Total Count : {count.totalCount}
                      </Tag>
                      <Tag style={{ padding: "8px", fontSize: "13px" }}>
                        Total Price : {price.totalPrice }
                      </Tag>
                     
                    </div>
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      ></Collapse>
      <Collapse
        style={{ width: "100%", marginTop: "20px" }}
        accordion={true}
        defaultActiveKey={["jobe"]}
        onChange={() => {
          loadJobStatusMetrics();
          loadJobs([1, 2, 3, 5, 6, 7, 8, 9]);
        }}
        items={[
          {
            key: "job",
            label: "Jobs",
            children: (
              <>
                <h3>Jobs counts by status</h3>
                <Row gutter={[16, 16]}>
                  <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                    <Button
                      type={
                        selectedStatuses.indexOf(2) > -1 ? "primary" : "default"
                      }
                      onClick={(e) => handleSelectStatus(2)}
                    >
                      Active -{" "}
                      {jobStatusMetric.find((item) => item.status == 2)
                        ?.count ?? 0}
                    </Button>
                  </Col>

                  <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                    <Button
                      type={
                        selectedStatuses.indexOf(3) > -1 ? "primary" : "default"
                      }
                      onClick={(e) => handleSelectStatus(3)}
                    >
                      Closed -{" "}
                      {jobStatusMetric.find((item) => item.status == 3)
                        ?.count ?? 0}
                    </Button>
                  </Col>

                  <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                    <Button
                      type={
                        selectedStatuses.indexOf(1) > -1 ? "primary" : "default"
                      }
                      onClick={(e) => handleSelectStatus(1)}
                    >
                      Drafted -{" "}
                      {jobStatusMetric.find((item) => item.status == 1)
                        ?.count ?? 0}
                    </Button>
                  </Col>

                  <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                    <Button
                      type={
                        selectedStatuses.indexOf(6) > -1 ? "primary" : "default"
                      }
                      onClick={(e) => handleSelectStatus(6)}
                    >
                      Internal -{" "}
                      {jobStatusMetric.find((item) => item.status == 6)
                        ?.count ?? 0}
                    </Button>
                  </Col>

                  <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                    <Button
                      type={
                        selectedStatuses.indexOf(5) > -1 ? "primary" : "default"
                      }
                      onClick={(e) => handleSelectStatus(5)}
                    >
                      Archive -{" "}
                      {jobStatusMetric.find((item) => item.status == 5)
                        ?.count ?? 0}
                    </Button>
                  </Col>

                  <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                    <Button
                      type={
                        selectedStatuses.indexOf(8) > -1 ? "primary" : "default"
                      }
                      onClick={(e) => handleSelectStatus(8)}
                    >
                      Ordered -{" "}
                      {jobStatusMetric.find((item) => item.status == 8)
                        ?.count ?? 0}
                    </Button>
                  </Col>

                  <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                    <Button
                      type={
                        selectedStatuses.indexOf(9) > -1 ? "primary" : "default"
                      }
                      onClick={(e) => handleSelectStatus(9)}
                    >
                      Rejected -{" "}
                      {jobStatusMetric.find((item) => item.status == 9)
                        ?.count ?? 0}
                    </Button>
                  </Col>

                  <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                    <Button
                      type={
                        selectedStatuses.indexOf(7) > -1 ? "primary" : "default"
                      }
                      onClick={(e) => handleSelectStatus(7)}
                    >
                      Removed -{" "}
                      {jobStatusMetric.find((item) => item.status == 7)
                        ?.count ?? 0}
                    </Button>
                  </Col>
                </Row>

                <h3 style={{ marginTop: "50px" }}>Billing actions</h3>
                <Row style={{ marginBottom: "20px" }}>
                  <Col xs={12} lg={6}>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Select a year"
                      onChange={handleYearChange}
                      allowClear
                      value={selectedYear}
                    >
                      {years.map((year) => (
                        <Select.Option key={year} value={year}>
                          {year}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  <Col xs={12} lg={6}>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Select a month"
                      onChange={handleChange}
                      allowClear
                      value={selectedMonth}
                    >
                      {months.map((month) => (
                        <Select.Option key={month.value} value={month.value}>
                          {month.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "20px" }}>
                  <Col span={24}>
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      {" "}
                      Jobs count : {allJobs.length}
                    </p>
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      {" "}
                      Highlighted count : {highlightedCount}
                    </p>
                  </Col>
                </Row>

                <Table
                  loading={loading}
                  size="small"
                  dataSource={jobs}
                  columns={jobCols}
                  rowKey="_id"
                  pagination={{ pageSize: 200 }}
                />
              </>
            ),
          },
        ]}
      ></Collapse>
      <Collapse
        style={{ width: "100%", marginTop: "20px" }}
        accordion={true}
        defaultActiveKey={["prem"]}
        onChange={premiumPosting}
        items={[
          {
            key: "premium",
            label: "Premium Posting",
            children: (
              <>
                <Table
                  loading={loading}
                  style={{ textAlign: "center", width: "100%" }}
                  rowKey="jobId"
                  columns={premiumPostColumn}
                  dataSource={premiumPosts}
                />
              </>
            ),
          },
        ]}
      ></Collapse>
      <Row style={{ marginTop: "20px" }}>
        <Col>
          <h3>Applications count - {applicationsCount}</h3>
        </Col>
      </Row>
    </>
  ) : null;
};

export default CompanyDetailed;
